var map = {
	"./data-icon.svg": "12f5",
	"./input-icon.svg": "27cb",
	"./layer-icon.svg": "d1eb",
	"./logo.png": "9d64",
	"./loss-icon.svg": "c4a3",
	"./nn_logo.svg": "986c",
	"./optimiser-icon.svg": "d385",
	"./output-icon.svg": "bba1",
	"./python-icon.svg": "8f8d",
	"./train-icon.svg": "1863",
	"./transform-icon.svg": "04e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";